import { useQuery } from 'react-query'

import { RequestMileageConfiguration } from '@webapp/modules/expense/entities/RequestMileageConfiguration'
import { expenseQueryConfig } from '@webapp/modules/expense/query-configs/expense'

type UseQueryMileageConfigurationReturn = {
  mileageConfiguration: RequestMileageConfiguration | null
  isLoading: boolean
  isError: boolean
}

export const useQueryMileageConfiguration =
  (): UseQueryMileageConfigurationReturn => {
    const { data, isLoading, isError } = useQuery(
      expenseQueryConfig.requestMileageConfiguration()
    )

    return {
      mileageConfiguration: data ? new RequestMileageConfiguration(data) : null,
      isLoading,
      isError,
    }
  }
